/**
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2021 Pearson Education, Inc. All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */

/**
 * Translation file for Korean language
 *
 * @file ko.js
 * @author Manimaran.S
 */

const ko = {
  'popularChannelSlider.allChannels': '전체 채널',
  'popularChannelSlider.recommended': '권장됨',
  'hero.myetextbook.link': '라이브러리',
  'hero.myetextbook.text': '올바른 타이틀이 아닌가요? 본인의 e텍스트북에 액세스하세요',
  'hero.etextfeaturestitle': '학습 자료를 e텍스트북에서 찾으세요',
  'hero.etextfeaturesdescription': '원하는 성공을 거두도록 설계된 학습 자료가 e텍스트북에 포함됩니다. 플래시 카드 등을 활용하여 e텍스트북에서 학습하세요.',
  'aichat.title1': '본 e텍스트북과 관련하여 무엇이든 AI 기반의 도움을 받아보세요.',
  'aichat.chatDesc1': '시작하려면 질문을 입력하세요',
  'subscriptiontext.isSubscribed': '구독의 일부',
  'subscriptiontext.nonSubscriber': '무제한 이용으로 업그레이드',
  'topicConatiner.otherHeader': '관련 비디오와 연습',
  'topicConatiner.exactLiteHeader': '관련 개념과 연습',
  'moremenu.downloadApp': '앱 다운로드하기',
  'moremenu.downloadAppAlreadyDownload': '다른 기기에서 앱을 다운로드하려면 %Click here% 그런 다음 자동으로 로그인하거나 본인의 고유 QR 코드를 사용하여 이미 설치한 앱에서 안전하게 로그인하세요.',
  'moremenu.downloadAppNotDownload': '앱을 다운로드하려면 %Click here% 그런 다음 본인의 고유 QR 코드로 안전하게 로그인하세요.',
  'channel.noBundletitle': '본인과 관련된 코스 및 그 외 다른 코스를 위한 \'학습·준비\'를 이용하세요',
  'onboard.studyPlan': '맞춤형 학습 플랜이 생성되었습니다!',
  'onboard.addCourseAnother': '다른 코스를 추가하고 싶으세요?',
  'onboard.purchase': 'Pearson e텍스트북을 구입해야 합니다',
  'onboard.addCourseWithoutEtext': '학습·준비를 이용하여 코스를 추가하세요',
  'onboard.mayBeLater': '나중에 변경할게요',
  'onboard.aboutCourse': '귀하의 코스에 관해 설명해 주세요',
  'onboard.close': '닫기',
  'course.addTitle': '코스 추가',
  'common.PURCHASE': '구입',
  'common.CLOSE': '닫기',
  'open': '열기',
  'continue': '계속하기',
  'yes': '예',
  'no': '아니오',
  'audio': '오디오',
  'courses.toc.PUBLISH_SUCCESS': '성공!',
  'courses.toc.PUBLISH_MESSAGE': '다음에 학생들이 콘텐츠를 열 때 해당 변경 내용을 볼 수 있습니다.',
  'errors.GENERIC_TITLE': '현재 액세스 권한이 없습니다',
  'errors.GENERIC_DESC': '우선 페이지를 새로고침하거나 캐시를 삭제해 보세요. 문제가 해결되지 않으면 Pearson에 문의하세요',
  'errors.GENERIC_LINK': '지원.',
  'errors.GENERIC_CODE': '오류 코드: {code}',
  'errors.SUBSCRIPTION_GENERIC_TITLE': '구독을 찾을 수 없습니다',
  'errors.SUBSCRIPTION_GENERIC_DESC': '귀하의 계정은 이 타이틀에 대한 액세스 권한이 없습니다. 이 메시지가 잘못 수신되었다고 판단되면 피어슨 기술 지원팀에 문의하세요',
  'errors.SUBSCRIPTION_REGISTRATION_TITLE': '구독을 찾을 수 없습니다',
  'errors.SUBSCRIPTION_REGISTRATION_DESC': '귀하의 구독에는 eText에 대한 액세스 권한이 없지만, 신용 카드를 사용해 지금 즉시 구독할 수 있습니다.',
  'link.ACCESSIBILITY': 'https://www.pearson.com/us/accessibility.html',
  'link.PRIVACY': 'https://pi.pearsoned.com/v1/piapi/login/static/html/PearsonPrivacyPolicy.html',
  'link.SUPPORT': 'https://support.pearson.com/getsupport/s/?_ga=2.116082310.1845539610.1557867919-NimtqV7BcT00BM9xOXCQUFJYwF3RzEIk',
  'link.TOSURL': 'https://pi.pearsoned.com/v1/piapi/login/static/html/PearsonEULA.html',
  'link.FAQS_NONMOJO': '',
  'link.TERMS_OF_USE_NONMOJO': 'https://www.pearson.com/en-us/legal-information/terms-of-use.html',
  'link.PRIVACY_NOTICE_NONMOJO': 'https://www.pearson.com/en-us/legal-information/privacy-policy.html',
  'link.ACCESSIBILITY_SUPPORT_NONMOJO': '',
  'menu.myAccount': '내 계정',
  'menu.helpCenter': '지원 센터',
  'menu.preferencesCenter': '환경 설정 센터',
  'menu.CONTACT_SUPPORT': '지원팀 문의',
  'menu.HELP_SUPPORT': '도움말 & 지원',
  'menu.FAQS': '자주 묻는 질문',
  'menu.CHAT_WITH_SUPPORT': '지원팀에 문의하세요',
  'menu.OTP_CODES': 'OTP 코드',
  'menu.LAUNCH_CODE': '코드 로그 시작',
  'menu.SEND_CODE': '사용자에게 이메일로 새 코드를 전송',
  'menu.SEND_CODE_PHONE': '사용자에게 문자 메시지로 새 코드를 전송',
  'menu.LEGAL': '법률 정보',
  'menu.PRIVACY_NOTICE': '개인정보 보호 정책',
  'menu.TITLE_INFO': '타이틀 정보',
  'menu.PEARSON_ACCESSIBILITY': 'Pearson 접근성',
  'menu.DEVICE_WARNING_MESSAGE': '{deviceLimit}대의 기기를 등록하세요. 한 달 1회 변경하세요.',
  'menu.ACCESSIBILITY': '접근성',
  'menu.ACCESSIBILITY_SUPPORT': '접근성 지원',
  'menu.DEVICES': '최근 기기',
  'menu.THIS_DEVICE': '이 기기',
  'menu.GET_THE_APP_DOWNLOAD': '모바일 앱 다운로드하기',
  'menu.MOJO_APP_INFO': '오프라인에서 Pearson+를 이용하려면 휴대폰 또는 태블릿에서 앱 스토어로 이동하세요',
  'menu.DEVICE_LABEL': '기기',
  'menu.DEVICE_DISCONNECT': '연결 해제',
  'menu.FOXIT': 'Foxit 제공',
  'menu.TERMS_OF_USE': '이용 약관',
  'menu.SIGN_OUT': '로그아웃',
  'menu.PRINT_PAGE': '페이지 인쇄',
  'menu.COPY_RIGHT': '저작권 © {year} 피어슨 에듀케이션(주) 무단 전재를 금합니다.',
  'print.FOOTER_MESSAGE': '{fullName}({email})에서 {currentDate}에 인쇄.',
  'print.WATERMARK': '저작권 © {year} 피어슨 에듀케이션(주)',
  'device.SWAPPED_ALREADY': '이번 달에 이미 변경했습니다',
  'device.SWITCH_DEVICE': '현재 기기로 변경하시겠어요?',
  'device.SWITCH_ONCE': '한 달 1회 변경할 수 있으므로 이 기기를 취소할 수 없습니다.',
  'device.SEAT_TAKEN': '해당 자리가 찼습니다',
  'device.DISCONNECT_DEVICE': '3대의 기기에 한해 로그인할 수 있습니다. 여기에서 계속하려면 다른 기기를 해제하세요.',
  'device.ALERT_TEXT': '한 달에 한 번만 기기 변경이 가능하다는 점을 명심하세요.',
  'device.DISCONNECT': '연결 해제',
  'device.CONTINUE': '계속하기',
  'device.HEADER': '다른 브라우저 세션을 종료할까요?',
  'device.CLOSE': '홈으로 되돌아가기',
  'device.CODE': '계속하려면 {maskedEmail}로(으로) 전송해 드린 인증 코드를 입력하세요. 문제가 있나요? {email} 스팸 보관함을 체크하시거나, {support}로(으로) 문의하세요.',
  'device.TIMER': '코드 입력 시간이 {time} 남았습니다',
  'device.RESEND': '{resend}',
  'device.FAQ': '자주 묻는 질문(FAQ)',
  'device.RESEND_NAME': '다시 전송하기',
  'device.NOTE': '직장과 자택 등 2곳에서 정기적으로 Pearson+를 이용하는 경우, 이용 후에는 반드시 로그아웃하세요. 또한 Pearson+ 모바일 앱은 최대 2대의 기기에서 사용할 수 있습니다. 자세한 내용은 당사의 {faq}을 참조하세요.',
  'device.NOTE_HEADER': '다음에는 이를 방지하세요',
  'device.CONTACT_SUPPORT': '고객 지원팀',
  'device.CONTACT_EMAIL': '나의 이메일 업데이트',
  'device.INCORRECT': '정확하지 않습니다. 코드를 재확인하거나 다시 전송하세요.',
  'device.MANY_ATTEMPTS': '시도 횟수가 너무 많습니다. 코드를 다시 전송하세요',
  'device.EXPIRED': '시간이 만료되었습니다. 코드를 다시 전송하세요',
  'device.ACCESS_HEADER': '성공했습니다!',
  'device.ACCESS_DESC': '세션이 인증되었습니다. 지금 비밀번호를 변경하시겠어요?',
  'device.ACCESS_CHANGE_PASSWORD': '비밀번호를 변경할게요',
  'device.ACCESS_RESET_PASSWORD': '비밀번호 재설정',
  'device.THREATONE_TITLE': '아무 문제가 없습니까?',
  'device.THREATONE_DESC': '귀하의 계정에서 일부 의심스러운 활동이 포착되었습니다.',
  'device.THREATONE_DESC_TWO': '지금 비밀번호를 변경하시는 게 좋습니다.',
  'device.MAY_BE_LATER': '나중에 변경할게요',
  'device.OKAY': '확인',
  'device.ACCOUNT_LOCK_DESC': '보안 유지를 위해 귀하를 로그아웃하는 중입니다. 귀하의 계정과 연결된 이메일 주소로 비밀번호 재설정 링크를 전송했습니다.',
  'device.ACCOUNT_LOCK_TITLE': '귀하의 계정에서 일부 의심스러운 활동이 포착되었습니다',
  'device.ACCOUNT_LOCK_TIMER': '에서 귀하는 로그아웃될 예정입니다 {time}',
  'navigation.PAGE': '페이지',
  'launchcode.CREATEBY': '생성자:',
  'launchcode.sentvia': '로(으로) 전송:',
  'launchcode.CODEINLAST': '지난 7일간 코드:',
  'launchcode.TIMESENT': '전송 시간:',
  'launchcode.ACCOUNTEMAIL': '계정 이메일:',
  'launchcode.LAUNCHDIALOGTITLE': 'OTP 코드 로그',
  'textmessage.TITLE': '전화번호 입력',
  'textmessage.PHONE_NUMBER': '전화번호',
  'textmessage.SEND_CODE': '코드 전송',
  'textmessage.INVALID_NUMBER': '휴대폰 번호가 올바르지 않습니다.',
  'textmessage.SUCCESS_MESSAGE': '전송한 코드',
  'remove.title': '타이틀을 제거하시겠어요?',
  'remove.subTitle': '나중에 언제든 되돌릴 수 있으니 이를 다시 추가하려면 검색을 이용하세요.',
  'remove.buttonText': '제거',
  'search.searchPlaceHolderPPlus': 'ISBN, 타이틀 또는 저자로 검색',
  'search.searchPlaceHolderEText': '나의 라이브러리 검색',
  'footer.downloadMobileApp': '모바일 앱 다운로드하기',
  'footer.termsOfUse': '이용 약관',
  'footer.privacy': '프라이버시',
  'footer.cookies': '쿠키',
  'footer.doNotSellMyPersonalInformation': '제 개인 정보를 판매하지 마세요',
  'footer.accessibility': '접근성',
  'footer.patentNotice': '특허 공지',
  'footer.copyrights': 'Pearson 무단 전재를 금합니다.',
  'hero.toc.defaultPlacehoder': '--- 주제 선택 ---',
  'hero.openEtextBookV1': 'E텍스트북 열기',
  'hero.heroHeading': '현재 <span>{channel_title}</span>\n을(를) 공부하고 있기 때문에',
  'hero.heroHeadingForBundleUser': '학습 연습',
  'hero.study.help': '학습 지원 받기',
  'hero.study.jumpBackIn': '이전으로',
  'hero.study.numOfUsers': '현재 <b>{num_of_users}</b> 명의 학생들이 채널을 이용하고 있습니다.',
  'hero.heroChannel.cardsHeading': '중단한 지점에서 계속 진행하세요',
  'hero.marketingcard1.copy.title': '비디오로 학습하세요',
  'hero.marketingcard1.copy.description': '까다로운 내용을 세분화한 짧은 비디오 설명을 시청하세요.',
  'hero.marketingcard2.copy.title': '연습 문제',
  'hero.marketingcard2.copy.description': '실제 시험의 느낌을 주는 수천 가지 문제와 비디오 솔루션으로 시험을 준비하세요',
  'hero.marketingcard3.copy.title': '경험이 풍부한 분들의 도움을 받으세요',
  'hero.marketingcard3.copy.description': '질문을 올린 후 해당 주제의 전문가 답변을 받아 보세요.',
  'hero.popularTopics.heading': '이 채널에서 인기 있는 다른 주제(topics)',
  'hero.popularChannels.headingv1': '다른 코스를 듣고 있나요?',
  'hero.popularChannels.descriptionv2': '인기 있는 학습 지원 주제를 둘러보세요.',
  'hero.practice': '연습',
  'hero.herobook.mappedChannelHeading': '이 채널에서 추천되는 학습 지원',
  'libraryL2.myBooks': '나의 도서',
  'libraryL2.archived': '아카이브 보관됨',
  'libraryL2.back': '뒤로',
  'hero.practiceProblem': '연습 문제',
  'nativeAppBanner.drawer.title': '다음에서 열기...',
  'nativeAppBanner.drawer.pearsonApp': 'Pearson+ 앱',
  'nativeAppBanner.banner.title': 'Pearson+ 앱',
  'nativeAppBanner.banner.description': '언제 어디서나 학습',
  'hero.promotionalcard.list1': '까다로운 주제를 단순화한 짧은 비디오',
  'hero.promotionalcard.list2': '실제 시험과 유사한 수천 가지 문제',
  'hero.promotionalcard.list3': '해당 분야의 전문가 답변을 받아 보세요',
  'hero.studyandexamprep': '학습 연습',
  'hero.heroBook.sectionSubHeadingV1': '자신의 코스에 맞춤화된 연습 문제와 비디오 설명으로 어려운 주제를 세분화해서 공부해 보세요.',
  'hero.heroBook.sectionSubHeadingV2': '자신의 코스에 맞춤화된 연습 문제와 개념 설명으로 어려운 주제를 세분화해서 공부해 보세요.',
  'hero.SeeAllStudyOptions': '모든 학습 옵션 보기',
  'hero.herobook.mappedChannelHeadingV1': '추천 비디오와 연습 문제',
  'hero.popularTopics.headingV1': '기타 인기 있는 주제',
  'hero.heroHeadingV1': '<span>{replace_value}</span>용',
  'hero.learnmore': '더 알아보기',
  'hero.eTextbook': 'e텍스트북',
  'hero.goToPage.label': '페이지 이동',
  'subscription.studyTitle': '학습 연습',
  'print.printAvailTitle': '이 페이지를 프린트하시겠어요? 방법은 다음과 같습니다',
  'print.printAvailDesc': '본인의 e텍스트북에서 우측 상단에 있는 계정 아이콘을 선택합니다. 해당 옵션에서 "페이지 인쇄(Print page)"를 선택한 다음 인쇄 설정을 선택하세요.',
  'print.printNotAvailTitle': '이 eText 인쇄 옵션이 활성화되어 있지 않습니다.',
  'print.printNotAvailDesc': '오프라인으로 편리하게 이용하도록 Pearson+ 모바일 앱을 통해 타이틀을 다운로드하고 언제 어디서나 유연하게 학습하세요!',
  'hero.header.cta': '학습 도구로 이동',
  'hero.header.ctav2': '학습·준비 열기',
  'hero.marketing.title': '나의 e텍스트북 찾기',
  'hero.marketing.subTitle': '오디오, 플래시 카드, 메모 등으로 구성된 2,000개가 넘는 e텍스트북에서 선택하세요. 4달간 한 달에 10.99달러만 내시면 됩니다.',
  'hero.popularchannels.desc': '최고로 인기 있는 과목의 학습 지원을 받으세요',
  'hero.removecourse.title': '대시보드에서 코스를 제거하시겠습니까?',
  'hero.removecourse.description': '"코스 추가"를 클릭하면 대시보드에 이 코스를 언제든 다시 추가하실 수 있습니다.',
  'hero.removecourse.primaryCtaText': '제거',
  'hero.removecourse.secondaryCtaText': '취소',
  'hero.tableOfContents': '목차',
  'hero.search': '검색',
  'hero.emptystate.cta': 'e텍스트북 검색',
  'hero.watch_it_again': '다시 시청하세요',
  'hero.mondly.learnLang.title': '무료로 새로운 언어를 배워 보세요',
  'hero.mondly.subTitle': 'Pearson e텍스트북 이용자에게는 Pearson에서 Mondly 3개월 무료 혜택을 드립니다.',
  'hero.mondly.description': '대부분의 언어 학습 앱은 영어를 기반으로만 다른 언어를 배울 수 있습니다. 그러나 가장 좋은 방법은 바로 모국어를 기반으로 학습하는 것입니다. Mondly에서는41개 언어로 다른 언어를 학습할 수 있습니다.',
  'hero.mondly.startLearningCTA': '학습 시작',
  'hero.mondly.marketing.bestApp': '최고의 앱',
  'hero.mondly.marketing.appStore': '앱 스토어',
  'hero.mondly.marketing.appYear': '올해의 앱',
  'hero.mondly.marketing.fbStart': '페이스북 FbStart - 2017 EMEA 수상자',
  'hero.mondly.marketing.editorChoice': '에디터 초이스',
  'hero.mondly.marketing.googlePlay': '구글 플레이',
  'header.menu.learnLanguage': '언어를 배워 보세요',
  'header.menu.moreAtPearson': 'Pearson에서 더보기',
  'hero.subscriptionStatusTitle2': 'Pearson+ 리소스',
  'hero.startStudying': '학습 시작하기',
  'onboard.studyMaterials': '주제를 선택하시면 맞춤식 학습 자료가 있는 대시보드를 생성해 드립니다.',
  'hero.myETextbooks': '나의 e텍스트북',
  'header.continueInTheApp': '앱에서 계속하기',
  'hero.learnTxt': '알아보기',
  'hero.examPrepTxt': '시험 준비',
  'hero.aITutorTxt': 'AI 튜터 선생님',
  'AI.toolTip': '무엇이든 e텍스트북에 관해 물어보세요',
  'hero.studyExamPrepAllYourCourses': '전체 코스를 위한 학습·준비',
  'header.qrCode.subHeaderTxt': 'QR 코드를 이용하여 신속하고 안전하게 모바일 기기의 Pearson+ 앱에 로그인하십시오.',
  'header.qrCode.dontHaveApp': '앱이 없으신가요?',
  'header.qrCode.footerTxt': '이 코드를 스캔하면 앱 스토어 또는 구글 플레이로 리디렉션됩니다. 앱을 다운로드하면 다시 스캔하여 로그인하십시오.',
  'header.qrCode.errorMsg': 'QR 코드가 로딩되지 않았습니다. 종료 후 다시 시도해 보세요.',
  'hero.yourETextbook': '나의 e텍스트북',
  'onboard.addCourseWithEtextBundle': '학습·준비를 이용하여 코스를 추가하세요',
  'onboard.disableTooltipText': '모든 학습 준비 코스가 추가되었습니다!',
  'subscriptionstatus.bundlecta': '학습·준비를 이용하세요',
  'subscriptionstatus.nonbundlecta': '학습·준비를 이용하세요',
  'channel.genericBundle': '학습·준비를 이용하여 다른 코스에서 도움을 받아보세요',
  'channel.relatedBundle': '학습·준비를 이용하여 다른 코스에서도 도움을 받아보세요',
  'onboard.courseAdded': '코스가 추가되었습니다!',
  'hero.flashcards': '플래시 카드(들)',
  'relatedChannelCard.title': '이러한 관련 리소스를 이용하여 학습 강화',
  'relatedChannelCard.badgeText': '관련된 학습·준비',
  'sessionInactivity.title': '지금 제 말을 듣고 계신가요?',
  'sessionInactivity.description': '비활성 상태로 인해 <b>{TIMER}</b> 후에 세션이 만료됩니다.<br/>로그인 상태를 유지할까요?',
  'sessionInactivity.keepMeSignIn': '로그인 상태로 유지',
  'sessionInactivity.signOut': '로그아웃',
  'sessionTimeout.title': '세션이 만료됨',
  'sessionTimeout.description': '비활성 상태로 인해 세션이 만료되었습니다.',
  'print.qrCode.header': '이 QR 코드를 이용하여 모바일 기기의 Pearson+ 앱을 여세요.',
  'print.qrCode.footer': '이 코드를 스캔하면 앱 스토어 또는 구글 플레이로 리디렉션됩니다. 앱을 설치한 후 로그인하여 타이틀을 다운로드하고 이용하세요.',
  'hero.nestest.title': '교사 자격증 시험을 준비하세요',
  'hero.nestest.subTitle': 'Pearson+ 이용자는 전국 표준에 맞춘 대비 코스와 모의 시험을 이용하여 교사 자격증 시험을 준비할 수 있습니다.',
  'hero.channelAI.title': '도움이 필요하세요? AI 튜터 선생님이 도와드리겠습니다.',
  'hero.channelAI.desc': '질문하신 후 단계별로 숙제 도움, 학습 추천 등 필요할 때마다 맞춤형 도움을 받아 보세요.',
  'hero.channelAI.action': '지금 AI 튜터 선생님께 질문해 보세요',
  'new': '새로워졌어요!',
  'hero.practice.numOfUsers': '이 섹션에는 <b>{practice_num_of_users}</b> 연습 문제가 있습니다.',
  'hero.practice.cta': '지금 연습하기',
  'hero.practice.title': '연습 문제',
  'diagnostics.errorMsg': '\'진단\'이 로딩되지 않았습니다. 종료 후 다시 시도해 보세요.',
  'qrcode.title': '어디서든 학습을 시작하세요',
  'qrcode.subtitle': 'Pearson+ 모바일 앱으로 언제 어디서나 학습하세요. 지금 다운로드하여 원활한 학습 경험을 누려보세요.',
  'qrcode.detailsv1': 'Pearson+ 앱으로 QR 코드를 이용하면 중단한 지점부터 이어서 학습할 수 있습니다. 어디서든 도서 검색, 플래시 카드 학습, 비디오 강의 시청 등을 누려보세요.',
  'qrcode.detailsv2': '이 QR 코드를 스캔하여 빠르게 로그인하고 중단한 지점부터 이어서 학습하세요.',
  'qrcode.details': 'Pearson+ 앱으로 QR 코드를 이용하여 중단한 지점부터 이어서 학습할 수 있습니다.',
  'qrcode.appstore': '앱 스토어',
  'qrcode.playstore': '구글 플레이',
  'nativePromoBanner.description': 'Pearson+ 모바일 앱으로 언제 어디서나 학습하세요. 지금 다운로드하여 원활한 학습 경험을 누려보세요.',
  'install': 'Install',
  'header.menu.createCourse': '새로운 코스',
  'header.dropdown.courses': '코스',
  'header.dropdown.recentlyViewed': '최근 확인',
  'header.dropdown.viewAll': '모든 코스 보기',
  'aet.courseHeader.inviteStudents': '학생 초대',
  'aet.courseHeader.inviteStudentModal.subTitle': '이메일 또는 수업 계획서에 아래의 링크 주소나 안내 지침을 복사하여 학생이 본 e텍스트북에 접속하도록 초대하세요.',
  'aet.courseHeader.inviteStudentModal.linkAddress': '링크 주소',
  'aet.courseHeader.inviteStudentModal.copyLink': '링크 복사',
  'aet.courseHeader.inviteStudentModal.instructionsTitle': '링크 주소가 포함된 안내 지침',
  'aet.courseHeader.inviteStudentModal.copyInstructions': '안내 지침',
  'aet.courseHeader.inviteStudentModal.instructionIntro': '{courseName}의 e텍스트북 {bookTitle}에 접속할 시간입니다.\n\n',
  'aet.courseHeader.inviteStudentModal.instructionAccessLink': '준비되면 {enrollmentLink}을 통해 e텍스트북에 접속하세요.\n\n',
  'aet.courseHeader.inviteStudentModal.instructionSignIn': '기존의 Pearson 계정으로 로그인하라는 요청을 받게 됩니다. Pearson 계정이 없다면 새 계정을 생성할 수 있습니다.\n\n',
  'aet.courseHeader.inviteStudentModal.instructionHelp': '도움이 필요하신가요?',
  'aet.courseHeader.inviteStudentModal.instructionHelpLink': 'AskPearson',
  'aet.courseHeader.startDate': '시작일:',
  'aet.courseHeader.endDate': '종료일:',
  'aet.courseHeader.entitlement': 'Entitlement:',
  'aet.courseHeader.format': '형식:',
  'aet.home.manageroster': '명단 관리',
  'aet.home.managegradesync': '성적 동기화 관리',
  'aet.home.copycourse': '코스 복사',
  'aet.home.unlinkcourse': 'Unlink course',
  'aet.tempAccess.warningBannerMessage': 'Temporary access expires on {date}',
  'aet.tempAccess.alertBannerMessage': 'Temporary access ends in {days} days. Upgrade to avoid interruptions.',
  'aet.tempAccess.upgradeAccessLabel': 'Upgrade access',
  'aet.tempAccess.expiredTitle': 'Temporary access has expired',
  'aet.tempAccess.expiredWithActionDescription': 'Your progress has been saved. Upgrade your access now to continue where you left off.',
  'aet.tempAccess.manageRoster.bannerMessage': 'One or more students have temporary access that has expired or may expire before all assignments are due.',
  'aet.tempAccess.manageRoster.emailActionLabel': 'Get student emails and access instructions',
  'aet.tempAccess.manageRoster.email.title': 'Student emails and access instructions',
  'aet.tempAccess.manageRoster.email.subTitle': 'Help students maintain access to their eTextbook by sharing the following instructions',
  'aet.tempAccess.manageRoster.email.recipientsLabel': 'Affected student email addresses',
  'aet.tempAccess.manageRoster.email.instructionsLabel': 'Access instructions',
  'aet.tempAccess.manageRoster.email.greeting': 'Dear Student,',
  'aet.tempAccess.manageRoster.email.paragraph1': 'Your temporary access for {courseName} may no longer be active. To maintain access to your eTextbook and your reading assignments, upgrade your access as soon as possible.',
  'aet.tempAccess.manageRoster.email.paragraph2': 'Once you\'ve accessed your course, you should see a prompt to upgrade. If not, follow these steps:',
  'aet.tempAccess.manageRoster.email.bullet1': 'Go to my account by selecting the circle with your initials in the upper right',
  'aet.tempAccess.manageRoster.email.bullet2': 'Go to Manage subscription',
  'aet.tempAccess.manageRoster.email.bullet3': 'Look for your eTextbook and follow the prompts to upgrade your access',
  'aet.tempAccess.manageRoster.email.footerPrefix': 'You can find detailed directions for how to upgrade, including a video walkthrough here: ',

  'aet.instructorCourse.tabs.current': '현재',
  'aet.instructorCourse.tabs.past': '과거',
  'aet.instructorCourse.tabs.courseSettings': '코스 설정',
  'aet.instructorCourse.tabs.assignmentSettings': 'Assignment settings',
  'aet.instructorCourse.assignmentSettings.lmsAlertMessage': 'Important: Your LMS may also have assignment scoring settings. Changes in both places are applied together. To avoid unintended changes to final scoring, update settings in one place.',
  'aet.instructorCourse.assignmentSettings.gradebookSectionTitle': 'Display assignment scores in gradebook as',
  'aet.instructorCourse.assignmentSettings.gradebookInfoButtonAriaLabel': 'Learn about raw score and equal weighting',
  'aet.instructorCourse.assignmentSettings.rawScoreTitle': 'Raw score',
  'aet.instructorCourse.assignmentSettings.rawScoreDescription': 'Assignment scores vary based on the number of questions in each assignment.',
  'aet.instructorCourse.assignmentSettings.equalWeightingTitle': 'Equal weighting',
  'aet.instructorCourse.assignmentSettings.equalWeightingDescription': 'All assignments have the same base value.',
  'aet.instructorCourse.assignmentSettings.baseValueLabel': 'Base value:',
  'aet.instructorCourse.assignmentSettings.availabilitySectionTitle': 'Assignment availability',
  'aet.instructorCourse.assignmentSettings.availabilityFieldLabel': 'Assignments are available to students',
  'aet.instructorCourse.assignmentSettings.dueDatesSectionTitle': 'Scheduling defaults',
  'aet.instructorCourse.assignmentSettings.defaultDueTimeLabel': 'Default due time',
  'aet.instructorCourse.assignmentSettings.courseTimeZoneLabel': 'Course time zone',
  'aet.instructorCourse.assignmentSettings.cancelButtonLabel': 'Cancel',
  'aet.instructorCourse.assignmentSettings.saveButtonLabel': 'Save changes',
  'aet.instructorCourse.assignmentSettings.gradebookInfoModalTitle': 'Raw Score vs Equal Weighting',
  'aet.instructorCourse.assignmentSettings.gradebookInfoRawScoreHeading': 'Raw Score:',
  'aet.instructorCourse.assignmentSettings.gradebookInfoRawScoreBody': 'Grades reflect total points earned out of total points possible across all assignments. Longer or higher-point assignments naturally impact the final grade more.',
  'aet.instructorCourse.assignmentSettings.gradebookInfoEqualWeightingHeading': 'Equal Weighting:',
  'aet.instructorCourse.assignmentSettings.gradebookInfoEqualWeightingBody': 'Every assignment is normalized using a consistent base value so that each task contributes equally to the final grade, regardless of length or point total.',
  'aet.instructorCourse.assignmentSettings.baseValueRequired': 'Base value is required',
  'aet.instructorCourse.assignmentSettings.baseValueInvalid': 'Enter a value between 1 and 100',
  'aet.instructorCourse.assignmentSettings.availability.immediate': 'Immediately upon publish',
  'aet.instructorCourse.assignmentSettings.availability.fourWeeksBefore': '4 weeks before due date',
  'aet.instructorCourse.assignmentSettings.availability.twoWeeksBefore': '2 weeks before due date',
  'aet.instructorCourse.assignmentSettings.availability.oneWeekBefore': '1 week before due date',
  'aet.instructorCourse.tabs.manageRoster': '명단 관리',
  'aet.instructorCourse.currentCourses.title': '현재 코스',
  'aet.instructorCourse.pastCourses.title': '지난 코스',
  'aet.instructorCourse.createOrCopy.title': 'Pearson e텍스트북 코스 생성 또는 복사',
  'aet.instructorCourse.createOrCopy.sectionTitle': '다른 강사의 코스를 복사하거나 새로 생성',
  'aet.instructorCourse.createOrCopy.copyPanel.title': '다른 강사의 코스를 복사',
  'aet.instructorCourse.createOrCopy.copyPanel.subtitle': '복사하고 싶은 해당 코스를 찾으려면 코스 ID를 입력하세요.',
  'aet.instructorCourse.createOrCopy.copyPanel.courseIdLabel': '코스 ID',
  'aet.instructorCourse.createOrCopy.copyPanel.courseIdPlaceholder': '코스 ID 입력',
  'aet.instructorCourse.createOrCopy.copyPanel.searchedForPrefix': '입력한 검색어:',
  'aet.instructorCourse.createOrCopy.catalogPanel.title': '카탈로그에서 새로운 코스 생성',
  'aet.instructorCourse.createOrCopy.catalogPanel.subtitle': '타이틀, 저자, ISBN 또는 과목 키워드로 검색하세요.',
  'aet.instructorCourse.createOrCopy.catalogPanel.searchPlaceholder': '검색...',
  'aet.instructorCourse.createOrCopy.showMoreLabel': '자세히 표시',
  'aet.instructorCourse.createOrCopy.showLessLabel': '간략히 표시',
  'aet.instructorCourse.cancel': '취소',
  'aet.instructorCourse.loading': '로딩 중...',
  'aet.instructorCourse.courseForm.copyError': 'Your course cannot be copied because the title is no longer supported. Please contact your Pearson representative or customer support.',
  'aet.instructorCourse.courseForm.gradeSync': '성적 동기화',
  'aet.instructorCourse.courseForm.gradeSyncLinkLabel': '성적 동기화 관리',
  'aet.instructorCourse.courseForm.courseNameLabel': '코스명',
  'aet.instructorCourse.courseForm.courseNamePlaceholder': '제목 없음',
  'aet.instructorCourse.courseForm.sectionNameLabel': '섹션명',
  'aet.instructorCourse.courseForm.sectionNamePlaceholder': '제목 없음',
  'aet.instructorCourse.courseForm.institutionFieldLabel': '기관',
  'aet.instructorCourse.courseForm.institutionSelectLabel': 'Select an Institution',
  'aet.instructorCourse.courseForm.institutionPlaceholder': 'Start typing your institution',
  'aet.instructorCourse.courseForm.institutionRequiredError': '기관은 필수입니다',
  'aet.instructorCourse.courseForm.institutionSearchError': '문제가 발생했습니다. 다시 시도하세요.',
  'aet.instructorCourse.courseForm.institutionNoResults': '결과를 찾을 수 없습니다',
  'aet.instructorCourse.courseForm.findAnotherInstitutionLabel': 'Find another institution',
  'aet.instructorCourse.courseForm.higherEducationSectionLabel': 'Higher Education:',
  'aet.instructorCourse.courseForm.k12InstitutionsSectionLabel': 'K12 Institutions:',
  'aet.instructorCourse.courseForm.k12InstitutionsDescription': 'Go to your My Courses dashboard to create courses for this type of institution',
  'aet.instructorCourse.courseForm.createK12CourseLabel': 'Create K-12 course',
  'aet.instructorCourse.courseForm.k12EmptyStateHeadline': 'Creating a K–12 course?',
  'aet.instructorCourse.courseForm.k12EmptyStateDescription': 'You\'ll have to create it outside Pearson+. After that\'s complete, you\'ll be able to manage it here.',
  'aet.instructorCourse.courseForm.startDateLabel': '코스 시작일',
  'aet.instructorCourse.courseForm.endDateLabel': '코스 종료일',
  'aet.instructorCourse.courseForm.datePlaceholder': 'dd/mm/yy',
  'aet.instructorCourse.courseForm.allowCopyLabel': '다른 사람이 이 코스를 복사하도록 허용',
  'aet.instructorCourse.courseForm.shareCodeLabel': '이 코스를 복사하고 싶은 강사들과 이 코드를 공유',
  'aet.instructorCourse.courseForm.copyCodeLabel': '코드 복사',
  'aet.instructorCourse.courseForm.optionalSuffix': '(선택 사항)',
  'aet.instructorCourse.courseForm.formValidationLiveRegion': '입력한 정보에 오류가 있습니다',
  'aet.instructorCourse.courseForm.submitContinue': '계속하기',
  'aet.instructorCourse.courseForm.submitContinueLoading': '저장 중...',
  'aet.instructorCourse.courseForm.submitError': '코스를 생성할 수 없습니다. 다시 시도하세요',
  'aet.instructorCourse.courseForm.submitEditError': '변경 내용을 저장할 수 없습니다. 다시 시도하세요',
  'aet.instructorCourse.courseForm.submitSaveChanges': '변경 내용 저장',
  'aet.instructorCourse.courseForm.materialsHeader': '코스 자료',
  'aet.instructorCourse.courseForm.resolveError': '코스 자료를 불러올 수 없습니다. 다시 시도하세요',
  'aet.instructorCourse.courseForm.copySourceError': 'We could not load the course to copy. Please search again from Create or copy course.',
  'aet.instructorCourse.coursesSort.lastViewed': '최근 보기',
  'aet.instructorCourse.coursesSort.recentlyAdded': '최근에 추가됨',
  'aet.instructorCourse.coursesSort.aToZ': 'A에서 Z까지',
  'aet.instructorCourse.coursesSort.zToA': 'Z에서 A까지',
  'aet.instructorCourse.manageRoster.column.name': '이름',
  'aet.instructorCourse.manageRoster.column.role': '역할',
  'aet.instructorCourse.manageRoster.column.email': '이메일',
  'aet.instructorCourse.manageRoster.column.access': 'eTextbook Access',
  'aet.instructorCourse.manageRoster.column.status': '상태',
  'aet.instructorCourse.manageRoster.enrolledDate': '등록됨 {date}',
  'aet.instructorCourse.manageRoster.enrolledLabel': 'Enrolled:',
  'aet.instructorCourse.manageRoster.changeTo': 'Change to:',
  'aet.instructorCourse.manageRoster.access.expired': 'Expired',
  'aet.instructorCourse.manageRoster.access.tempAccessDays': '{days}-day temp access',
  'aet.instructorCourse.manageRoster.notAvailable': '---',
  'aet.instructorCourse.manageRoster.access.active': 'Active',
  'aet.instructorCourse.manageRoster.access.inactive': 'Inactive',
  'aet.instructorCourse.manageRoster.access.tempAccess': 'Temporary',
  'aet.instructorCourse.roster.role.student': '학생',
  'aet.instructorCourse.roster.role.ta': '보조 강사(TA)',
  'aet.instructorCourse.roster.role.instructor': '강사',
  'aet.instructorCourse.roster.status.active': '활성화',
  'aet.instructorCourse.roster.status.inactive': '비활성',
  'aet.instructorCourse.manageRoster.filter.allMembers': '전체 구성원',
  'aet.instructorCourse.manageRoster.filter.activeStudents': '활성 학생',
  'aet.instructorCourse.manageRoster.filter.inactiveStudents': '비활성 학생',
  'aet.instructorCourse.manageRoster.filter.teachingAssistant': '보조 강사',
  'aet.instructorCourse.manageRoster.filter.instructor': '강사',
  'aet.instructorCourse.courseForm.materialsAuthorLabel': '저자:',
  'aet.instructorCourse.courseForm.materialsIsbnLabel': 'ISBN:',
  'aet.instructorCourse.courseForm.materialsCreationDateLabel': '코스 생성 날짜:',
  'aet.instructorCourse.noCoursesFound': '코스를 찾을 수 없습니다',
  'aet.instructorCourse.backButton': '뒤로',
  'aet.instructorCourse.selectCourse': '코스 선택',
  'aet.home.linkedToLms': 'LMS에 연결됨',
  'aet.instructorCourse.courseForm.title.create': '코스 생성',
  'aet.instructorCourse.courseForm.title.copy': '코스 복사',
  'aet.instructorCourse.courseForm.title.edit': '코스 정보',
  'aet.instructorCourse.courseForm.copiedContentAccordion.assignments.title': '과제(들)',
  'aet.instructorCourse.courseForm.copiedContentAccordion.assignments.content': '과제 내용',
  'aet.instructorCourse.courseForm.copiedContentAccordion.assignments.dueDates': '과제 마감일',
  'aet.instructorCourse.courseForm.copiedContentAccordion.highlightsAndNotes.title': '강조 표시 및 메모',
  'aet.instructorCourse.courseForm.copiedContentAccordion.highlightsAndNotes.highlightColor': '강조 표시 색상',
  'aet.instructorCourse.courseForm.copiedContentAccordion.highlightsAndNotes.noteText': '메모 내용',
  'aet.instructorCourse.courseForm.copiedContentAccordion.highlightsAndNotes.sharedStatus': '공유 상태',
  'aet.instructorCourse.courseForm.copiedContentAccordion.studentRosterAndEngagement.title': '학생 명단과 참여도',
  'aet.instructorCourse.courseForm.copiedContentAccordion.studentRosterAndEngagement.studentNames': '학생 이름',
  'aet.instructorCourse.courseForm.copiedContentAccordion.studentRosterAndEngagement.emailAddresses': '이메일 주소',
  'aet.instructorCourse.courseForm.copiedContentAccordion.studentRosterAndEngagement.enrollments': '등록',
  'aet.instructorCourse.courseForm.copiedContentAccordion.studentRosterAndEngagement.completionAndInsights': '이수 및 인사이트',
  'aet.instructorCourse.courseForm.copiedContentAccordion.settings.title': '설정',
  'aet.instructorCourse.courseForm.copiedContentAccordion.settings.aiToolEnablement': 'AI Tool enablement',
  'aet.instructorCourse.courseForm.copyAccordionTitle': 'Show what’s copied',
  'aet.instructorCourse.courseForm.copyAccordionSubTitle': '복사된 데이터',
  'aet.studentRoster.manageStudentRosterButton': '학생 명단 관리',
  'aet.studentRoster.dontHaveAnyStudent': 'Looks like you don’t have any students.',
  'aet.studentRoster.lmsEmptyState.title': 'No students have accessed the course yet',
  'aet.studentRoster.lmsEmptyState.description': 'As soon as students click through from your LMS, you’ll see their names and progress here.',
  'aet.studentRoster.nonlmsEmptyState.description': 'As soon as students join your course, you’ll see their names and progress here.',
  'aet.syllabus.editContentDisabledTooltip': 'Cannot update assignment while student work is in progress.',
  'aet.assignments.exportStudentProgressButton': '학생 진척도 내보내기',
  'aet.home.student.roaster.enrolmentInformationTitle': 'Enrolment information',
  'aet.home.student.roaster.enrolmentInformation.status': '상태:',
  'aet.home.student.roaster.enrolmentInformation.enrolled': '등록됨:',
  'aet.home.student.roaster.enrolmentInformation.access': 'Access:',
  'aet.home.student.roaster.enrolmentInformation.role': '역할:',
  'aet.home.student.roaster.enrolmentInformation.promotionCardTitle': '{studentName}을(를) 지정하겠습니까?',
  'aet.home.student.roaster.enrolmentInformation.promotionCardContent1': '보조 강사는 이 수업을 듣는 모든 학생의 진척도와 수행 능력을 볼 수 있습니다.',
  'aet.home.student.roaster.enrolmentInformation.promotionCardContent2': '또한 학생과 과제를 관리할 수 있습니다. 하지만 해당 수업을 삭제할 수는 없습니다.',
  'aet.home.student.roaster.enrolmentInformation.promotionCardConfirmLabel': '보조 강사로 지정',
  'aet.home.manageRoster.searchPlaceholder': '학생 검색',
  'aet.home.manageRoster.inactivateButtonLabel': '선택된 학생을 비활성',
  'aet.home.manageRoster.FilterLabel': '표시',
  'aet.home.manageRoster.updatingMessage': '명단을 업데이트 중입니다... 몇 분 정도 소요될 수 있습니다.',
  'aet.home.courses.search.searchPlaceHolder': '나의 코스 검색',
  'aet.courses.emptyStateDescription': '아래 옵션을 선택하여 코스 구축을 시작하세요.',
  'nativePromoBanner.continueInBrowser': '브라우저에서 계속',
  'globalnav.tooltip.hideNavText': '탐색 숨기기',
  'globalnav.tooltip.showNavText': '탐색 표시',
  'aet.syllabus.progressTitle': '추출 중...',
  'aet.syllabus.progressDesc': '수업 계획서를 처리하는 동안 잠시 기다려 주세요.',
  'aet.syllabus.uploadInputLabel': '여기로 파일을 드래그하여 놓거나 클릭하여 업로드하세요',
  'aet.syllabus.uploadSyllabusTabLabel': '수업 계획서 업로드하기',
  'aet.syllabus.dateAdjusterTabLabel': '날짜 조정기',
  'aet.syllabus.addManuallyTabLabel': '수동으로 과제 추가',
  'aet.syllabus.addEditLaterText': '나중에 언제든지 과제를 추가하거나 편집할 수 있습니다',
  'aet.syllabus.editAssignmentLabel': '과제 편집',
  'aet.syllabus.addAssignmentLabel': '과제 추가',
  'aet.syllabus.assignmentTitleLabel': '과제 타이틀',
  'aet.syllabus.assignmentTitleAutoPlaceholder': 'Automatically generated',
  'aet.syllabus.dueDateLabel': '마감일',
  'aet.syllabus.editDueDateLabel': '마감일 수정',
  'aet.syllabus.chaptersCoveredLabel': '포함할 챕터 또는 섹션을 선택하세요.',
  'aet.syllabus.updateCtaLabel': '과제 업데이트',
  'aet.syllabus.addCtaLabel': '과제 추가',
  'aet.syllabus.uploadLabel': '업로드',
  'aet.syllabus.confirmLabel': '확인',
  'aet.syllabus.addContentLabel': '콘텐츠 추가',
  'aet.syllabus.addEditContentLabel': '콘텐츠 추가/편집',
  'aet.syllabus.notPublishedLabel': '게시되지 않음',
  'aet.syllabus.updateDatesLabel': '날짜 업데이트',
  'aet.syllabus.dateNormalization.yearAdjustedContentSingle': '마감일이 수정되었습니다. 검토한 후 게시하세요.',
  'aet.syllabus.coverageDedupe.adjustedContent': '챕터/섹션 정보가 수정되었습니다. 검토한 후 게시하세요.',
  'aet.syllabus.unassignedCoverageStatus': '일부 챕터는 아직 배정되지 않았습니다. 게시하기 전에 배정해 주세요.',
  'aet.syllabus.dateNormalization.manualEntryContent': 'Add a due date before you publish.',
  'aet.syllabus.pastDuePublishStatus': 'Update due date before you publish.',
  'aet.deleteAssignmentTitle': '과제를 삭제할까요?',
  'aet.deleteAssignmentTitleMultiple': '과제를 삭제할까요?',
  'aet.deleteAssignmentWarning': '이 작업은 취소가 불가능하며 모든 관련 제출물과 학생 데이터가 더는 보이지 않게 됩니다.',
  'aet.deleteAssignmentKeepCTA': '과제 유지',
  'aet.deleteAssignmentDeleteCTA': '삭제',
  'aet.assignments.loadingAsset': '에셋 로딩 중...',
  'aet.assignments.addToDate': '날짜 추가하기',
  'aet.assignments.previewAsStudent': '학생 화면으로 미리 보기',
  'aet.assignments.questionsAndTopics': '질문 및 주제',
  'aet.assignments.questionsAndTopicsModal.doneLabel': '완료',
  'aet.assignments.questionsAndTopicsModal.dueDateLabel': '마감일',
  'aet.assignments.questionsAndTopicsModal.questionsTotalLabel': '전체 문제',
  'aet.assignments.questionsAndTopicsModal.questionOfTotalLabel': '문항 {count}/{total}',
  'aet.assignments.publishToStudents': '학생들에게 게시',
  'aet.assignments.availableToStudentsOn': 'Available to students on {0}',
  'aet.syllabus.addDateLabel': '날짜 추가하기',
  'aet.doneLabel': '완료',
  'aet.assignments.dueDateLabel': '과제 마감일',
  'aet.assignmentNameLabel': 'Assignment name',
  'aet.assignment.nameDisabledPlaceholder': 'Add content to generate a default name for your assignment',
  'aet.assignment.nameGeneratedPlaceholder': 'Automatically generated assignment name based on selected content',
  'aet.onboarding.getStarted.title': 'Get started creating assignments now',
  'aet.onboarding.getStarted.manualSetup.title': '수동 설정',
  'aet.onboarding.getStarted.manualSetup.description': 'Create and customize individual reading assignments and set their due dates',
  'aet.onboarding.getStarted.assistedScheduling.title': 'Assisted scheduling',
  'aet.onboarding.getStarted.assistedScheduling.description': 'Automatically set all due dates and easily add chapter content from your eTextbook',
  'aet.onboarding.getStarted.autoCreateAssignments.title': 'Auto-create assignments',
  'aet.onboarding.getStarted.autoCreateAssignments.description': 'Upload your syllabus to generate all reading assignments in seconds',
  'aet.onboarding.promotion.title': 'Hold students accountable with assigned reading',
  'aet.onboarding.promotion.feature.1': 'Create multiple assignments within minutes, with optional grade sync to your LMS',
  'aet.onboarding.promotion.feature.2': '실시간 인사이트를 활용하여 학습 격차를 파악하고 조기에 자신 있게 대응하세요',
  'aet.onboarding.promotion.feature.3': '맞춤형 피드백과 내장된 Pearson AI를 통해 학생들이 더욱 세심한 지원을 받습니다',
  'aet.assistedSchedule.pageTitle': 'Assisted scheduling',
  'aet.assistedSchedule.reviewPageTitle': 'Create your assignments',
  'aet.assistedSchedule.sectionTitle': 'Set a recurring assignment schedule',
  'aet.assistedSchedule.sectionDescription': 'We\'ll create assignment slots throughout your course that you can populate with content from your eTextbook.',
  'aet.assistedSchedule.dueDaysLabel': 'Due day(s)',
  'aet.assistedSchedule.dueDaysTip': 'Tip: Make assignments due 1 or 2 days before your class meets in order to get the most out of assignment insights',
  'aet.assistedSchedule.dueDaysPlaceholder': 'Choose',
  'aet.assistedSchedule.dueDaysRequiredError': 'Select at least one day',
  'aet.assistedSchedule.dueTimeRequiredError': 'Due time is required',
  'aet.assistedSchedule.timeZoneRequiredError': 'Time zone is required',
  'aet.assistedSchedule.startDateLabel': 'Starts on',
  'aet.assistedSchedule.endDateLabel': 'Ends on',
  'aet.assistedSchedule.datePlaceholder': 'mm/dd/yyyy',
  'aet.assistedSchedule.startDateRequiredError': 'Start date is required',
  'aet.assistedSchedule.endDateRequiredError': 'End date is required',
  'aet.assistedSchedule.scheduleInstruction': 'Drag content into the assignment slots to build your schedule.',
  'aet.assistedSchedule.dragZoneLabel': 'Drag content here to assign it to students',
  'aet.assistedSchedule.clickToEditLabel': 'Click to edit',
  'aet.assistedSchedule.clearDataLabel': 'Clear data',
  'aet.assistedSchedule.formValidationLiveRegion': 'Form has validation errors',
  'aet.assistedSchedule.noQuestionsError': 'Each assignment must include content with at least one question.',
  'aet.assistedSchedule.noQuestionsWarningLabel': 'Add content with at least 1 question to save this assignment.',
  'aet.assistedSchedule.noAssignmentsModalTitle': 'No assignments can be created',
  'aet.assistedSchedule.noAssignmentsModalMessage': 'The selected date range is too short to generate any assignments. Extend the date range and try again.',
  'aet.assignments.allCaughtUpDescription': '이번 주에는 완료해야 할 과제가 없습니다.',
  'aet.assignments.progressTitle': '진행 상황',
  'aet.assignments.performanceTitle': '자신감',
  'aet.assignments.completionTitle': '완료',
  'aet.assignments.statusTitle': '상태',
  'aet.assignments.addTooltip': '과제 추가',
  'aet.assignments.deleteTooltip': '선택한 과제 삭제',
  'aet.assignments.selectToDeleteLabel': '선택 및 삭제 모드',
  'aet.assignments.bulkEditTooltip': '과제 일괄 편집',
  'aet.assignments.title': '과제(들)',
  'aet.assignments.assignmentTitle': '과제',
  'aet.assignments.dueDate': '마감일',
  'aet.tabular.searchPlaceholder.assignments': '과제 검색',
  'aet.tabular.searchPlaceholder.students': '학생 검색',
  'aet.tabular.searchPlaceholder.questions': '학생 검색',
  'aet.assignemnts.columnDueDateInfoTooltip': '모든 과제에 대하여 한 명 이상의 학생에게 마감일 연장이 적용되었습니다.',
  'aet.assignemnts.singleDueDateInfoTooltip': '이 과제에 대하여 한 명 이상의 학생에게 마감일 연장이 적용되었습니다.',
  'aet.assignemnts.masterDueDateInfoTooltip': '한 명 이상의 학생에게 마감일 연장이 적용되었습니다. 이 과제들을 확인하려면 정보 아이콘을 찾으세요.',
  'aet.home.loading': '로딩 중...',
  'aet.home.errorFetchingAssignments': '과제 가져오기 오류',
  'aet.home.dueThisWeekTitle': '이번 주 마감',
  'aet.home.allCaughtUpTitle': '다 되었습니다!',
  'aet.home.allCaughtUpDescription': '이번 주에는 완료해야 할 과제가 없습니다.',
  'aet.home.suggestedRemediationTitle': '\'학습 준비\' 추천 복습',
  'aet.home.noSuggestedRemediationTitle': '제안된 복습 자료 없음',
  'aet.home.noSuggestedRemediationDescription': '다음 과제 이후에 다시 확인해 보세요.',
  'aet.home.assignmentIncludesTitle': '과제 포함:',
  'aet.home.sectionsLabel': '챕터(들)',
  'aet.home.questionsCount': '{count} 문제',
  'aet.home.dueLabel': '마감 기한: {dueDate}',
  'aet.home.due': '마감 기한:',
  'aet.home.progressCompletedLabel': '완료됨',
  'aet.home.progressCompletedPastDueLabel': '마감 기한 이후에 완료됨',
  'aet.home.progressInProgressLabel': '진행 중',
  'aet.home.progressPartiallyCompleteLabel': 'Partially complete',
  'aet.home.progressNotStartedLabel': '시작 안 함',
  'aet.home.progressCountOfTotal': '총 {total}개 중 {count}개',
  'aet.home.NotAttemptedLabel': '시도하지 않음',
  'aet.home.questionsTotalLabel': '전체 문제',
  'aet.home.progressCompletedOnTimeLabel': '제시간에 완료됨',
  'aet.home.segmentGreatLabel': '매우 좋습니다',
  'aet.home.segmentGettingThereLabel': '확인',
  'aet.home.segmentNeedsReviewLabel': '노력 필요',
  'aet.home.segmentOkayLabel': '확인',
  'aet.home.editAssignmentTooltip': '과제 편집',
  'aet.home.deleteAssignmentTooltip': '과제 삭제',
  'aet.home.viewDetailsButton': '세부 정보 보기',
  'aet.home.viewAsStudentButton': '학생 관점으로 보기',
  'aet.home.welcomeButtonText': '시작하기 →',
  'aet.review.emptyStateTitle': '복습할 내용이 없습니다',
  'aet.review.emptyStateDescription': '다음 과제 이후에 다시 확인해 보세요.',
  'aet.dashboard.tabs.upNext': '다음',
  'aet.dashboard.tabs.welcome': '환영합니다',
  'aet.dashboard.tabs.assignments': '과제(들)',
  'aet.dashboard.tabs.review': '복습',
  'aet.dashboard.tabs.studentRoster': '학생(들)',
  'aet.dashboard.classSchedule': '수업 스케줄:',
  'aet.syllabus.dueTimeLabel': '마감 시간',
  'hero.accessEducatorGuides': '교육자 가이드 액세스',
  'aet.assignment.save': '저장',
  'aet.assignment.finish': '종료',
  'aet.assignment.saveAndAdd': '저장 및 새로 추가',
  'aet.assignment.delete': '삭제',
  'aet.assignment.saveAndClose': '저장 및 종료',
  'aet.studentRoster.title': '학생(들)',
  'aet.studentRoster.titlev1': '학생',
  'aet.studentRoster.dueDatesAdjustmentLabel': '마감일',
  'aet.studentRoster.dueDateAdjustment.option.0': '표준',
  'aet.studentRoster.dueDateAdjustment.option.2': '2일 후',
  'aet.studentRoster.dueDateAdjustment.option.3': '3일 후',
  'aet.studentRoster.dueDateAdjustment.option.5': '5일 후',
  'aet.studentRoster.dueDateAdjustment.option.week.1': '1주일 후',
  'aet.studentRoster.dueDateAdjustment.option.week.2': '2주일 후',
  'aet.studentRoster.dueDateAdjustment.option.lastDayOfClass': '수업 마지막 날',
  'aet.studentRoster.dueDateAdjustment.toast.partial.title.multiple': '{count}개의 과제가 업데이트되었습니다!',
  'aet.studentRoster.dueDateAdjustment.toast.partial.message': '마감일이 지난 과제들을 자동으로 업데이트할 수 없습니다. 새 마감일을 설정하려면 각 과제를 수정하세요.',
  'aet.studentRoster.dueDateAdjustment.toast.allPastDue.title': '마감일을 업데이트할 수 없습니다',
  'aet.studentRoster.dueDateAdjustment.toast.allPastDue.message': '모든 과제가 마감일이 지났으며 자동으로 업데이트하지 못했습니다. 새 마감일을 설정하려면 각 과제를 수정하세요.',
  'aet.bulkEdit.bulkSplitInstruction': '과제를 균등하게 나누어 드리겠습니다.',
  'aet.bulkEdit.Description': 'Figma ipsum component variant main layer. Editor library device auto star reesizing pencil horizontal. Polygon main list figjam star layout object connection hand scale.',
  'aet.bulkEdit.firstAssignmentDue': '첫 과제 마감일',
  'aet.bulkEdit.lastAssignmentDue': '마지막 과제 마감일',
  'aet.bulkEdit.assignmentsDueDays': '과제 마감일을 어느 요일에 원하시나요?',
  'aet.bulkEdit.addEditLaterText': '저희는 AI를 활용하여 과제를 생성합니다. 언제든 나중에 과제(들)를 추가하거나 편집할 수 있습니다.',
  'aet.bulkEdit.monday': '월요일',
  'aet.bulkEdit.tuesday': '화요일',
  'aet.bulkEdit.wednesday': '수요일',
  'aet.bulkEdit.thursday': '목요일',
  'aet.bulkEdit.friday': '금요일',
  'aet.bulkEdit.saturday': '토요일',
  'aet.bulkEdit.sunday': '일요일',
  'aet.toast.assignmentCreated.title': '과제가 생성되었습니다!',
  'aet.toast.assignmentCreated.single': '자동으로 {assignmentTitle}으로(로) 명명되었습니다',
  'aet.toast.assignmentCreated.multiple': '{count} 과제가 생성되었습니다',
  'aet.toast.assignmentUpdated.title': '성공적으로 업데이트되었습니다.',
  'aet.toast.assignmentUpdated.single': '{assignmentTitle} 업데이트되었습니다',
  'aet.toast.assignmentUpdated.multiple': '{count}개의 과제가 업데이트되었습니다',
  'aet.toast.assignmentPublished.single': '{count} assignment successfully published!',
  'aet.toast.assignmentPublished.multiple': '{count} assignments successfully published!',
  'aet.toast.assignmentPublished.subtitle': '과제 내용 수정은 학생들이 작업을 시작하기 전까지 가능합니다.',
  'aet.toast.viewAssignment': '과제 보기',
  'aet.toast.viewAssignments': '과제들 보기',
  'aet.welcome.title': 'Pearson e텍스트북이 현재 본인의 LMS 코스와 연결되었습니다',
  'aet.welcome.LMSAccounTitle': '인사이트 탐색하기',
  'aet.welcome.LMSAccounDescription': '수업에서 어려워하는 주제가 무엇인지 정확히 파악합니다.',
  'aet.welcome.createAssignmentsTitle': '과제 생성',
  'aet.welcome.createAssignmentsDescription': '수동으로 또는 내 수업 계획서를 업로드하여 챕터를 지정합니다.',
  'aet.welcome.progressViewTitle': 'LMS에서 수행력 추적하기',
  'aet.welcome.progressViewDescription': 'LMS 코스에서 성적 동기화(grade sync) 설정을 선택합니다.',
  'aet.assignmentDetails.noAssignmentFound': '과제를 찾을 수 없습니다',
  'aet.assignments.loadingErrorTitle': '현재 과제를 로딩할 수 없습니다',
  'aet.assignments.loadingErrorDescription': '새로 고침을 시도하거나 나중에 다시 확인해 보세요.',
  'aet.assignmentStudentDetails.noDataFound': '아직 데이터 없음',
  'aet.assignmentStudentDetails.noData': 'No data',
  'aet.studentRoster.noStudentsRegisteredYet': '등록한 학생이 없음',
  'aet.studentRoster.noStudentsRegisteredYetDescription': '학생들이 e텍스트북을 구입하면 내 수업에 학생들이 참여합니다.',
  'aet.home.editAssignmentTooltipDisabled': '편집 불가: 학생이 과제를 진행 중입니다',
  'aet.home.deleteAssignmentTooltipDisabled': '삭제 불가: 학생이 과제를 진행 중입니다',
  'aet.home.StudentDetails.questions': '질문(들)',
  'aet.home.StudentDetails.attempts': '시도',
  'aet.home.StudentDetails.comprehension': '자신감',
  'hero.titleInfo.tooltip': '타이틀 정보',
  'aet.home.publishAssignments': '모든 과제를 게시',
  'aet.assignments.saveScheduleAsDraft': '일정을 초안으로 저장',
  'aet.assignments.reviewBeforePublishAlert': '과제를 검토한 후 학생들이 볼 수 있도록 과제를 게시하세요',
  'aet.assignments.copiedCoursePublishAlert': '학생들이 볼 수 있도록 복사한 과제에 날짜를 추가하고 게시하세요.',
  'aet.assignments.allSetPublishAlert': '준비되었나요? 학생들이 볼 수 있도록 과제를 게시하세요',
  'aet.assignments.emptyStateTitle': 'No assignments yet',
  'aet.assignments.emptyStateDescription': 'Assignments you create will appear here',
  'aet.dashboard.footer': '일부 콘텐츠는 Pearson 학습 자료 기반의 AI를 이용하여 생성되었습니다. Pearson에서 결과물을 검증하는 프로세스를 거치지만, 생성형 AI는 사람, 장소 또는 사실과 관련하여 부정확한 정보를 도출할 수도 있습니다.',
  'aet.home.bulkEditTitle': '과제 일괄 편집',
  'aet.home.bulkEditSubtitle': '수업 계획서를 변경한 다음 여기에서 다시 업로드하세요. 과제와 마감 날짜가 업로드되어 일치됩니다.',
  'aet.home.createAssignmentTitle': '과제 생성',
  'aet.assignments.includedInAnotherAssignmentTooltip': '다른 과제에 포함됨',
  'aet.assignments.someSectionsIncludedInAnotherAssignmentTooltip': '일부 섹션은 다른 과제에 포함되어 있습니다',
  'aet.welcome.welcome.Title': '환영합니다!',
  'aet.home.student.roaster.ProgressTitle': '전체 완료',
  'aet.assignmentStudentDetails.startAssignmentDescription': '학생들이 과제를 시작하면 다시 확인합니다.',
  'aet.home.whatDueThisWeekTitle': '이번 주에 마감해야 할 내용입니다',
  'aet.assignments.edit.errorTitle': '{count} 과제에 오류가 있습니다',
  'aet.assignments.edit.errorSubTitle': '오류가 있는 과제는 게시할 수 없습니다. 과제를 편집하거나 과제 없이 게시하세요.',
  'aet.assignments.edit.publishAnyway': '이대로 발행',
  'aet.assignments.edit.editAssignments': '과제들을 편집',
  'aet.assignments.edit.validationInfoToolTip': '오류를 제거하기 위해 과제 편집',
  'aet.assignments.error.assignmentCreated.title': '모든 과제에 오류가 있습니다',
  'aet.assignments.error.assignmentCreated.description': '오류가 있는 과제는 게시할 수 없습니다. 과제를 편집하거나 다른 수업 계획서를 시도하세요.',
  'aet.assignments.error.uploadSyllabus': '수업 계획서 업로드하기',
  'aet.assignments.error.editAssignments': '과제들을 편집',
  'aet.mondly.title': '언어',
  'aet.studentRoster.errorState.title': '학생 목록이 없습니다',
  'aet.studentRoster.errorState.description': '학생 목록을 로딩할 수 없습니다. 새로 고침을 시도하거나 나중에 다시 확인하세요.',
  'aet.assignments.sectionLabel': '섹션(들)',
  'aet.assignments.sectionLabelCapitalized': 'Section(s):',
  'aet.assignments.sectionsPrefix': 'Sections:',
  'aet.assignments.chaptersPrefix': 'Chapters:',
  'aet.assignments.questionsLabel': '질문(들)',
  'aet.assignments.assignmentsLabel': '과제(들)',
  'aet.assignments.performanceProgressBar': '수행력 진행 바',
  'aet.assignments.completionProgressBar': '완료 진행 바',
  'aet.syllabus.deleteConfirmationSubtitleSingle': '이 과제를 삭제하시겠습니까?',
  'aet.syllabus.deleteConfirmationSubtitleBulk': '이 과제들을 삭제하시겠습니까?',
  'aet.home.nextAssignmentTitle': '다음 과제',
  'aet.home.courseSettings': '코스 설정',
  'aet.home.assignmentSettings': 'Assignment settings',
  'aet.home.pearsonETextbookResources': 'Pearson+ e텍스트북 리소스',
  'aet.home.etextbookInformation': 'e텍스트북 정보',
  'aet.multiple.deleteAssignmentKeepCTA': '과제(들) 유지',
  'aet.syllabus.processingText.header': '수업에 지정된 읽기를 정리하고 있습니다 - 잠시만 기다리시면 됩니다.',
  'aet.syllabus.processingText.uploading': '문서를 업로드 중',
  'aet.syllabus.processingText.activating': 'AI 구성 요소 활성화 중',
  'aet.syllabus.processingText.extracting': '읽기 과제 추출 중',
  'aet.syllabus.processingText.mapping': '교재 콘텐츠 매핑',
  'aet.syllabus.processingText.finishing': '마무리 중',
  'aet.syllabus.uploadErrorMessage': 'PDF 또는 .docx 파일 크기가 10MB 미만이고 인터넷 연결이 안정적인지 확인하세요',
  'aet.syllabus.uploadNoAssignmentsMessage': '읽기 과제를 찾을 수 없습니다',
  'aet.syllabus.uploadNoAssignmentsDescription': '이 파일에서 읽기 과제를 불러올 수 없습니다. 수동으로 추가할 수 있습니다.',
  'aet.syllabus.uploadFailedRetryCTA': '다시 시도하세요',
  'aet.syllabus.uploadModal.noAssignments.title': 'Couldn\'t find assignments',
  'aet.syllabus.uploadModal.noAssignments.body1': 'We weren\'t able to find any reading assignments within the uploaded syllabus.',
  'aet.syllabus.uploadModal.noAssignments.body2': '수업 계획서에 <qualities a syllabus should have for this to work>이(가) 포함되었는지 꼼꼼하게 확인한 후 다시 시도하거나 수동 과제 생성으로 전환하세요.',
  'aet.syllabus.uploadModal.noAssignments.manualCreationCTA': '수동 생성',
  'aet.syllabus.uploadModal.noAssignments.backToUploadCTA': 'Back to upload',
  'aet.syllabus.uploadModal.genericFailure.title': '오류가 발생했습니다',
  'aet.syllabus.uploadModal.genericFailure.body1': '수업 계획서를 업로드하고 처리하지 못했습니다.',
  'aet.syllabus.uploadModal.genericFailure.body2': '인터넷 연결을 확인한 후 다시 시도하거나 수동 과제 생성으로 전환하세요.',
  'aet.syllabus.uploadModal.successTotal.title': '검토 준비',
  'aet.syllabus.uploadModal.successTotal.body1': 'We found {count} assignments from your syllabus.',
  'aet.syllabus.uploadModal.successTotal.body2': 'Make any adjustments, then save or publish when you\'re ready. You can continue making changes before students start working.',
  'aet.syllabus.uploadModal.successPartial.title': '검토 준비',
  'aet.syllabus.uploadModal.successPartial.body1': 'We found {count} assignments from your syllabus.',
  'aet.syllabus.uploadModal.successPartial.body2': 'We couldn\'t find exact matches in the eTextbook for every item. Review your assignments to make any adjustments, then save or publish when you\'re ready.',
  'aet.syllabus.uploadModal.reviewAssignmentsCTA': '과제 검토',
  'aet.syllabus.selectChapterWithQuestions': '문제가 포함된 챕터를 선택하세요.',
  'preferenceSetting.subTitle': '이 설정은 이 코스의 모든 학생에게 기본값입니다.',
  'preferenceSetting.sections.isAIStudyEnabled.label': 'AI 인터랙션',
  'preferenceSetting.sections.isAIStudyEnabled.subLabel': '검색 결과에 AI 학습 도구와 AI 요약을 활성화',
  'preferenceSetting.sections.isStudyPrepEnabled.subLabel': '이 책과 관련된 \'학습 준비\' 리소스 표시',
  'aet.syllabus.footer': '과제 생성은 AI로 구동됩니다.',
  'aet.dashboard.footerDialogDeatils': 'Pearson 학습 자료 기반의 과제 문제를 생성하는 데 생성형 AI가 사용됩니다. Pearson에서 결과물을 검증하는 프로세스를 거치지만, 생성형 AI는 사람, 장소 또는 사실과 관련하여 부정확한 정보를 도출할 수도 있습니다. AI는 또한 귀하가 제공하는 수업 계획서 및/또는 일정에 기초하여 콘텐츠를 과제로 그룹화하는 데 사용됩니다.',
  'aet.review.footer': 'AI를 이용하여 생성됨',
  'aet.footerCard.dismiss': '해제',
  'preferenceSetting.sections.isStudyPrepEnabled.descriptionText1': '\'Study Prep\'은 학습을 지원하는 추가 도구이며 학생에게 본 코스에 맞춘 동영상과 연습 문제를 제공합니다.',
  'preferenceSetting.sections.isStudyPrepEnabled.descriptionText2': '이용권에 \'Study Prep\'이 포함되지 않은 학생은 \'Study Prep\' 리소스를 계속 이용하도록 구독 요청을 받을 수 있습니다.',
  'preferenceSetting.sections.isStudyPrepEnabled.descriptionText3': '이 설정은 이미 \'Study Prep\'을 구매한 학생에게 영향을 주지 않습니다.',
  'preferenceSetting.sections.isStudyPrepEnabled.helpLinkText': '\'학습 준비\' 혜택을 자세히 알아보세요',
  'aet.home.viewCourseId': '코스 ID 보기',
  'aet.home.copy': '복사',
  'aet.home.copied': '복사됨',
  'aet.home.courseLabel': '코스 ID:',
  'schoolInfoCard.addUniversity': '학교 추가',
  'schoolInfoCard.title': '학교 정보',
  'schoolInfoCard.titleV1': '귀하의 코스에 관해 설명해 주세요',
  'schoolInfoCard.cta': '시작하기',
  'schoolInfoCard.pickInstitution': '학교 선택',
  'schoolInfoCard.addUniversityTitle': '학교 추가하기',
  'schoolInfoCard.addUniversitySubtitle': '학교와 코스를 알려주시면 가장 유용한 학습 자료를 추천해 드릴 수 있습니다.',
  'schoolInfoCard.searchPlaceholder': '학교를 검색...',
  'schoolInfoCard.skip': '이 단계 건너뛰기',
  'schoolInfoCard.nextStep': '다음 단계',
  'schoolInfoCard.notInList': '우리 학교가 목록에 없음',
  'schoolInfoCard.noResults': '검색 결과와 일치하는 학교를 찾을 수 없습니다',
  'schoolInfoCard.noResultsHeading': '학교를 찾을 수 없나요?',
  'schoolInfoCard.noResultsInstruction': '아래에 전체 이름을 입력하세요',
  'schoolInfoCard.noResultsInputPlaceholder': '학교명',
  'schoolInfoCard.addInstitutionLabel': '이 학교 추가',
  'aet.assignments.assignmentTitlePlaceholder': '타이틀 입력',
  'aet.assignments.titleValidation.titleRequired': '과제 타이틀은 필수입니다.',
  'aet.assignments.titleValidation.titleTooLong': '과제 타이틀은 글자 수가 {0}자를 초과할 수 없습니다.',
  'aet.assignments.titleValidation.titleInvalidChar': '과제 타이틀에 지원하지 않는 문자가 포함되어 있습니다.',
  'aet.assignments.titleValidation.titleDuplicate': '과제 타이틀이 이미 존재합니다.',
  'aet.syllabus.timeZoneLabel': '시간대',
  'aet.review.reviewReadingFromAssignments': '읽기 과제 검토',
  'aet.assignments.chaptersLabel': '챕터(들)',
  'menu.myAccount.subTitle': '기관이 여기에 표시됩니다',
  'menu.myAccount.subTitleNotAvailable': '나중에 언제든지 여기에 기관을 추가할 수 있습니다.',
  'schoolInfoCard.toastMessage': '대학교 저장됨',
  'aet.review.threeDotMenu.askAI': 'AI에게 묻기',
  'aet.home.suggestedRemediationSubtitle': '관련 동영상을 시청하고 연습하여 코스 주제를 마스터하세요.',
  'aet.home.laggedQuestionLabel': '표시한 문제',
  'aet.home.correctAnswer': '정답',
  'aet.home.incorrectAnswer': '가장 흔한 오답',
  'aet.home.behaviourTrendsLabel': '문제 인사이트',
  'aet.home.strugglingStudentsLabel': '힘들어하는 학생들',
  'aet.home.patternsInStudensAiLabel': '학생의 AI 사용 패턴',
  'aet.home.questionLabel': '문제',
  'aet.home.studentAskingSimilarQuestions': '유사한 질문을 한 학생들',
  'aet.home.assignmentDifficultQuestions': '어려운 문제',
  'aet.home.behaviorTrends': '문제 인사이트',
  'aet.home.behaviors': '수행 능력 지표',
  'aet.home.mostDifficultTopics': '가장 어려운 문제',
  'aet.home.commentsFromStudentLabel': '학생의 코멘트',
  'aet.home.disregard': '무시하기',
  'aet.home.reportAsInaccurate': '부정확한 것으로 신고하기',
  'aet.home.Flagged': '플래그 됨',
  'aet.home.reportQuestionTitle': '질문 신고하기',
  'aet.home.reportQuestionLabel': '이 문제에 어떤 잘못된 점이 있었나요?',
  'aet.home.showComments': '코멘트 표시',
  'aet.home.studentReports': '학생 리포트',
  'aet.home.placeholderText': '설명해 주세요...',
  'aet.home.reportQuestion.notRelevant': '관련 없음',
  'aet.home.reportQuestion.notCorrect': '부정확함',
  'aet.home.reportQuestion.unsafe': '안전하지 않음/해로움',
  'aet.home.reportQuestion.somethingElse': '그 외 다른 것',
  'aet.home.StudentDetails.assistedByAI': 'AI 지원',
  'aet.home.strugglingStudents.emptyStateTitle': '지금은 힘들어하는 학생이 없습니다',
  'aet.home.strugglingStudents.emptyStateDescription': '나중에 다시 확인하세요.',
  'aet.home.overallStatus.excelling': '매우 잘하고 있음',
  'aet.home.overallStatus.fallingBehind': '뒤처지고 있음',
  'aet.home.overallStatus.keepingUp': '진도 잘 따라가는 중',
  'aet.home.showOnlyDifficultQuestionsLabel': '\'어려운 문제\'만 표시',
  'aet.home.showOnlyStrugglingStudentsLabel': '\'힘들어하는 학생들\'만 표시',
  'aet.home.viewQuestionInAssignment': '과제 내 질문 보기',
  'aet.home.insightRisk.incorrectFirstAttempts': '첫 시도 오답',
  'aet.home.insightRisk.multipleIncorrectAttempts': '부정확한 시도가 많음',
  'aet.home.insightRisk.lowConfidence': '자신감 낮음',
  'aet.home.insightRisk.mediumConfidence': '자신감 중간',
  'aet.home.insightRisk.lowEngagement': '참여도 낮음',
  'aet.home.insightRisk.countOfStudents': '총 {total}명의 학생 중 {count}명',
  'aet.home.insightRisk.na': '해당 없음',
  'aet.home.strugglingStudentsHereLabel': '여기에서 힘들어하는 학생들',
  'aet.home.insightRisk.didNotAttempt': '시도하지 않음',
  'aet.home.insightRisk.attempted': 'Attempted',
  'aet.courseHeader.assignableEText': 'Assignable eText',
  'aet.courseHeader.lmsIntegration': 'LMS 연동',
  'aet.courseHeader.lmsIntegrationSubLabel': 'Connected to your LMS',
  'aet.instructorCourse.courseForm.institutionNotOfferedError': 'This institution does not offer this product.'
};

export default ko;
